document.addEventListener('DOMContentLoaded', function () {
    const subscribeOption = document.querySelector('.purchase_option_subscribe');
    const oneTimeOption = document.querySelector('.purchase_option_one-time');
    const deliveryOptions = document.querySelector('.delivery-options');
    const sellingPlanInput = document.querySelector('.selling_plan_input');

    if (!subscribeOption || !oneTimeOption || !deliveryOptions || !sellingPlanInput) {
        return;
    }

    function checkActiveOption() {
        const sellingPlansSelects = document.querySelector('input[name="selling_plan_view"]:checked');

        if (subscribeOption.checked && sellingPlansSelects) {
            sellingPlanInput.value = sellingPlansSelects.value;
        } else if (oneTimeOption.checked) {
            sellingPlanInput.value = '';
        }

    }

    deliveryOptions.addEventListener('change', function (event) {
        subscribeOption.checked = true;
        checkActiveOption();
    });


    checkActiveOption();

    subscribeOption.addEventListener('change', checkActiveOption);
    oneTimeOption.addEventListener('change', checkActiveOption);
});
